import { Flex as AntdFlex, FlexProps as AntdFlexProps } from "antd";
import { addKeyIfNotUndefined } from "common/utils/universal/object";
import React, { FC } from "react";

export type FlexProps = AntdFlexProps & { dataTestId?: string };

const Flex: FC<FlexProps> = ({ dataTestId, ...rest }) => {
  return (
    <AntdFlex {...rest} {...addKeyIfNotUndefined("data-testid", dataTestId)} />
  );
};

export default Flex;
